export default __webpack_public_path__ + "static/header-blue-df9bad52080e324584287cb184a38995.jpg";